import {
  addDays,
  eachDayOfInterval,
  format,
  startOfDay,
  startOfMonth,
  subDays,
  subMonths,
} from "date-fns";

export const NOW = () => new Date();

export const today = () => startOfDay(NOW());

export const daysAgo = (n) => subDays(today(), n);

export const last60Days = () =>
  eachDayOfInterval({ start: daysAgo(59), end: today() });

export const isoDate = (d) => format(d, "yyyy-MM-dd");

export const isoTimestamp = (d) => d.toISOString();

export const currentMonthFirst = () => startOfMonth(NOW());

export const previousMonthFirst = () => startOfMonth(subMonths(NOW(), 1));

export const inDaysFromNow = (n) => addDays(NOW(), n);
